import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=34aaa512&scoped=true"
import script from "./Article.vue?vue&type=script&lang=ts"
export * from "./Article.vue?vue&type=script&lang=ts"
import style0 from "./Article.vue?vue&type=style&index=0&id=34aaa512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aaa512",
  null
  
)

export default component.exports